import { render, staticRenderFns } from "./SingleCourse.vue?vue&type=template&id=7adb1d7e&scoped=true&"
import script from "./SingleCourse.vue?vue&type=script&lang=js&"
export * from "./SingleCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb1d7e",
  null
  
)

export default component.exports